import React from "react";

import PageHeaderContent from "../../components/pageHeaderContent";
import { Animate } from "react-simple-animate";
import "./styles.scss";
import { DiAndroid } from "react-icons/di";
import { FaDev, FaDatabase } from "react-icons/fa";

const personalDetails = [
  {
    label: "Name :",
    value: "Amit Giri",
  },
  {
    label: "Address :",
    value: "India",
  },
  {
    label: "Email :",
    value: "amitgiri00010@gmail.com",
  },
  {
    label: "Contact No :",
    value: "+91 7250599167",
  },
];

const About = () => {
  return (
    <section id="about" className="about">
      <PageHeaderContent headerText="About ME" />
      <div className="about__content">
        <div className="about__content__personalWrapper">
          <Animate
            play
            duration={1.5}
            delay={1}
            start={{
              transform: "translateX(-900px)",
            }}
            end={{
              transform: "translatex(0px)",
            }}
          >
            <p>
            Hey! It's Amit Giri 2024 graduate student and I'm a Full Stack Developer located in India. I've done internship and currently doing awesome freelancing projects, Over the last 1 year have done some freelancing projects that inhance my developments skills i have build many website from scratch and deploy that using firebse, netlify, render and connected DNS using goDaddy, Currently i am learning NextJS+typescript and kubernetes.
            And when i am not coding i like to read books and talk about astronautics, astronomy, history, philosophy and psychology. 

            </p>
          </Animate>

          <Animate
            play
            duration={1.5}
            delay={1}
            start={{
              transform: "translateX(500px)",
            }}
            end={{
              transform: "translatex(0px)",
            }}
          >
            <h3 className="personalInformationHeaderText">
              Personal Information
            </h3>
            <ul>
              {personalDetails.map((item, i) => (
                <li key={i}>
                  <span className="title">{item.label}</span>
                  <span className="value">{item.value}</span>
                </li>
              ))}
            </ul>
          </Animate>
        </div>
        <div className="about__content__servicesWrapper">
          <Animate
            play
            duration={1.5}
            delay={1}
            start={{
              transform: "translateX(600px)",
            }}
            end={{
              transform: "translatex(0px)",
            }}
          >
            <div className="about__content__servicesWrapper__innerContent">
              <div>
                <FaDev size={60} color="var( --aqua-theme-main-color)" />
              </div>
              {/* <div>
                <DiAndroid size={60} color="var( --aqua-theme-main-color)" />
              </div> */}
              <div>
                <FaDatabase size={60} color="var( --aqua-theme-main-color)" />
              </div>
              
            </div>
          </Animate>
        </div>
      </div>
    </section>
  );
};
export default About;
